export const initAccordion = () => {
  const accBars = document.getElementsByClassName('accordion__bar');

  if (accBars.length === 0) {
    return;
  }

  for (const accBar of accBars) {
    accBar.addEventListener('click', accBarClick(accBar));
  }
};

const accBarClick = accBar => () => {
  accBar.classList.toggle('--active');

  const panel = accBar.parentElement.getElementsByClassName('accordion__panel');
  if (!panel[0].classList.contains('--visible')) {
    Velocity(panel[0], 'slideDown');
    panel[0].classList.toggle('--visible');
  } else {
    Velocity(panel[0], 'slideUp').then(() => {
      panel[0].classList.toggle('--visible');
    });
  }
};
